export default __webpack_public_path__ + "static/corporate-0c039d89816d266585e003157855c02d.png";